<div id="header-container">
  <div id="home-container">
    <div role="button" id="home" (click)="home()"></div> 
  </div>
  <div id="logo-container">
    <!-- <img [attr.src]="game.name == 'match-mitanim' ? '../../assets/images/match-mitanim.svg' : (game.name == 'match-nosaim' ? '../../assets/images/match-nosaim.svg' : (game.name == 'trivia-mitanim' ? '../../assets/images/night-logo-mitanim.svg' : '../../assets/images/night-logo-nosaim.svg'))" -->
    <img [attr.src]="'./assets/images/' + game.name + '.svg'" id="logo">
  </div>
  <div id="back-container" [ngStyle]="{visibility: board ? 'visible' : 'hidden'}">
    <div role="button" id="back" (click)="back()"></div>
  </div>
</div>